import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitolonavalacab() {



    const cardData = {
"keyword": "Mumbai to Lonavala Cab",

"headingDescription":
  "Om Sai Cab offers reliable and comfortable Mumbai to Lonavala Cab service for travelers looking for a safe, affordable, and enjoyable short road trip to one of Maharashtra’s most popular hill stations. Whether you are planning a family outing, weekend getaway, romantic trip, friends tour, or corporate travel, our taxi service ensures a smooth and stress-free journey from Mumbai to Lonavala. With experienced drivers familiar with Mumbai–Pune Expressway routes, clean air-conditioned vehicles maintained for comfort, and transparent pricing with no hidden charges, we provide a dependable travel experience. Our fleet includes sedans, SUVs, Innova cars, tempo travellers, and premium vehicles suitable for solo travelers, families, and groups.",

"topPlaces": [
  {
    "title": "Bhushi Dam",
    "description":
      "Bhushi Dam is one of Lonavala’s most popular attractions known for overflowing steps, scenic water flow, and a lively picnic atmosphere during monsoon season."
  },
  {
    "title": "Tiger’s Leap",
    "description":
      "Tiger’s Leap is a famous cliff-top viewpoint offering breathtaking views of valleys, deep drops, and mist-covered hills in the Western Ghats."
  },
  {
    "title": "Karla Caves",
    "description":
      "Karla Caves are ancient Buddhist rock-cut caves known for their historic carvings, grand prayer hall, and spiritual significance."
  },
  {
    "title": "Bhaja Caves",
    "description":
      "Bhaja Caves are a group of ancient rock-cut caves featuring Buddhist stupas and carvings, offering a peaceful and historical experience."
  },
  {
    "title": "Lohagad Fort",
    "description":
      "Lohagad Fort is a historic hill fort known for trekking trails, strong fortification walls, and panoramic views of the surrounding valleys."
  },
  {
    "title": "Rajmachi Fort",
    "description":
      "Rajmachi Fort is a popular trekking destination offering lush green landscapes, ancient ruins, and scenic monsoon beauty."
  },
  {
    "title": "Lonavala Lake",
    "description":
      "Lonavala Lake is a calm and scenic spot surrounded by greenery, ideal for relaxation, photography, and peaceful picnics."
  },
  {
    "title": "Kune Waterfalls",
    "description":
      "Kune Waterfalls is a beautiful three-tier waterfall located between Lonavala and Khandala, especially stunning during monsoon season."
  },
  {
    "title": "Lion’s Point",
    "description":
      "Lion’s Point is a famous viewpoint known for sunrise and sunset views, misty hills, and breathtaking valley scenery."
  },
  {
    "title": "Sunil’s Celebrity Wax Museum",
    "description":
      "Sunil’s Celebrity Wax Museum features lifelike wax statues of famous personalities and is a popular family-friendly attraction in Lonavala."
  }
],



services: [
  {
    name: "Mumbai to Lonavala Taxi",
    description: "Mumbai to Lonavala taxi service provides reliable transportation for travelers planning comfortable hill station road journeys from Mumbai. Vehicles ensure smooth highway and ghat travel suitable for tourism, sightseeing tours, weekend trips, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Mumbai. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Mumbai to Lonavala Cab Package",
    description: "Mumbai to Lonavala cab package service offers complete transportation solutions for travelers planning enjoyable Lonavala vacations and sightseeing trips. Comfortable vehicles ensure smooth hill-route journeys suitable for tourism, family holidays, and weekend outings. Professional chauffeurs ensure reliable pickup and safe transportation services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Mumbai. Flexible booking options allow convenient cab package reservations."
  },
  {
    name: "Mumbai to Lonavala Taxi Price",
    description: "Mumbai to Lonavala taxi price service provides affordable and transparent transportation pricing for travelers planning hill station travel. Vehicles ensure smooth highway journeys suitable for tourism travel, sightseeing tours, and family vacations. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport areas across Mumbai. Flexible booking options allow convenient taxi price reservations."
  },
  {
    name: "One Way Cab from Mumbai to Lonavala",
    description: "One way cab from Mumbai to Lonavala service provides economical transportation for travelers requiring direct one-side hill station travel. Comfortable vehicles ensure reliable highway journeys suitable for tourists, couples, solo travelers, and family outings. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Mumbai. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Mumbai to Lonavala Taxi Cost",
    description: "Mumbai to Lonavala taxi cost service offers dependable transportation with transparent pricing for travelers planning comfortable road journeys to Lonavala. Vehicles ensure smooth highway and ghat travel suitable for tourism trips, family vacations, and sightseeing tours. Professional chauffeurs ensure reliable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport locations across Mumbai. Flexible booking options allow convenient taxi cost reservations."
  },
  {
    name: "Mumbai to Lonavala Car Rental",
    description: "Mumbai to Lonavala car rental service provides spacious and comfortable vehicles for travelers planning private hill station road trips. Vehicles ensure smooth highway journeys suitable for tourism, family holidays, and weekend travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airports across Mumbai. Flexible booking options allow convenient car rental reservations."
  },
  {
    name: "Mumbai to Lonavala Cab Price",
    description: "Mumbai to Lonavala cab price service provides economical transportation options for travelers seeking budget-friendly hill station travel. Comfortable vehicles ensure reliable highway journeys suitable for sightseeing tours, tourism trips, and family outings. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Mumbai. Flexible booking options allow convenient cab price reservations."
  },
  {
    name: "Mumbai to Lonavala Car Rental Price",
    description: "Mumbai to Lonavala car rental price service offers affordable transportation pricing for travelers planning comfortable road trips to Lonavala. Vehicles ensure smooth and safe highway journeys suitable for tourism, weekend getaways, and family vacations. Professional chauffeurs ensure dependable pickup and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Mumbai. Flexible booking options allow convenient car rental reservations."
  },
  {
    name: "Mumbai to Lonavala Cab Booking",
    description: "Mumbai to Lonavala cab booking service provides easy and convenient transportation reservations for travelers planning smooth hill station travel. Vehicles ensure comfortable highway journeys suitable for tourism, sightseeing tours, and family holidays. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Mumbai. Flexible booking options allow convenient cab booking reservations."
  },
  {
    name: "Lonavala Cab for 2 Days",
    description: "Lonavala cab for 2 days service provides comfortable transportation for travelers planning extended sightseeing and holiday trips in Lonavala. Vehicles ensure smooth local and highway travel suitable for tourism, family vacations, and weekend outings. Professional chauffeurs ensure dependable pickup and reliable transportation services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Mumbai. Flexible booking options allow convenient multi-day cab reservations."
  },
  {
    name: "Cab Service from Mumbai to Lonavala",
    description: "Cab service from Mumbai to Lonavala provides dependable transportation solutions for travelers planning direct hill station road travel. Comfortable vehicles ensure smooth highway journeys suitable for tourism trips, sightseeing tours, and family travel. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport locations across Mumbai. Flexible booking options allow convenient cab service reservations."
  },
  {
    name: "Mumbai Airport to Lonavala Cab",
    description: "Mumbai Airport to Lonavala cab service provides direct airport transportation for travelers planning comfortable hill station journeys from Mumbai Airport. Vehicles ensure smooth highway and ghat travel with spacious seating and luggage space suitable for airport passengers. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the route. Pickup services are available from all Mumbai Airport terminals and nearby airport locations. Flexible booking options allow convenient airport cab reservations."
  },
  {
    name: "Mumbai Airport to Lonavala Taxi Fare",
    description: "Mumbai Airport to Lonavala taxi fare service offers affordable and transparent pricing for travelers planning direct airport road travel to Lonavala. Comfortable vehicles ensure reliable highway journeys suitable for tourism travel, family holidays, and executive trips. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from airport terminals, hotels, and nearby airport areas across Mumbai. Flexible booking options allow convenient airport taxi fare reservations."
  },
  {
    name: "Mumbai Airport to Lonavala Taxi",
    description: "Mumbai Airport to Lonavala taxi service provides reliable airport transportation for travelers planning smooth road journeys to Lonavala. Vehicles ensure comfortable highway and hill-route travel suitable for tourism, family vacations, and weekend trips. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from airport terminals and nearby airport locations across Mumbai. Flexible booking options allow convenient airport taxi reservations."
  },
  {
    name: "Mumbai Lonavala Cab Service",
    description: "Mumbai Lonavala cab service offers comfortable transportation for travelers planning direct road journeys between Mumbai and Lonavala. Vehicles ensure smooth highway travel suitable for tourism, sightseeing tours, and family outings. Professional chauffeurs ensure reliable pickup and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Mumbai. Flexible booking options allow convenient cab service reservations."
  },
  {
    name: "Mumbai Central to Lonavala Taxi Fare",
    description: "Mumbai Central to Lonavala taxi fare service provides economical transportation pricing for travelers planning road travel from Mumbai Central to Lonavala. Comfortable vehicles ensure reliable highway journeys suitable for tourism travel and weekend vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from Mumbai Central railway station, nearby hotels, and surrounding areas. Flexible booking options allow convenient taxi fare reservations."
  },
  {
    name: "Mumbai Lonavala Taxi Fare",
    description: "Mumbai Lonavala taxi fare service offers affordable transportation pricing for travelers planning comfortable hill station road journeys. Vehicles ensure smooth highway travel suitable for tourism, sightseeing tours, and family holidays. Professional chauffeurs ensure dependable pickup and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Mumbai. Flexible booking options allow convenient taxi fare reservations."
  },
  {
    name: "Mumbai to Lonavala Cab Charges",
    description: "Mumbai to Lonavala cab charges service provides transparent transportation pricing for travelers planning direct road travel to Lonavala. Comfortable vehicles ensure smooth and safe highway journeys suitable for tourism, family vacations, and sightseeing tours. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Mumbai. Flexible booking options allow convenient cab charge reservations."
  },
  {
    name: "Mumbai to Lonavala Taxi Charges",
    description: "Mumbai to Lonavala taxi charges service offers affordable transportation pricing for travelers planning smooth hill station road journeys. Vehicles ensure reliable highway travel suitable for tourism trips, weekend outings, and family holidays. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby airport locations across Mumbai. Flexible booking options allow convenient taxi charge reservations."
  }
],

tableData: [
  ["Mumbai to Lonavala Taxi", "Mumbai to Lonavala Cab Package"],
  ["Mumbai to Lonavala Taxi Price", "One Way Cab from Mumbai to Lonavala"],
  ["Mumbai to Lonavala Taxi Cost", "Mumbai to Lonavala Car Rental"],
  ["Mumbai to Lonavala Cab Price", "Mumbai to Lonavala Car Rental Price"],
  ["Mumbai to Lonavala Cab Booking", "Lonavala Cab for 2 Days"],
  ["Cab Service from Mumbai to Lonavala", "Mumbai Airport to Lonavala Cab"],
  ["Mumbai Airport to Lonavala Taxi Fare", "Mumbai Airport to Lonavala Taxi"],
  ["Mumbai Lonavala Cab Service", "Mumbai Central to Lonavala Taxi Fare"],
  ["Mumbai Lonavala Taxi Fare", "Mumbai to Lonavala Cab Charges"],
  ["Mumbai to Lonavala Taxi Charges", "Mumbai to Lonavala Taxi"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai to Lonavala Cab Service",
    WhyChoosedescription: "Om Sai Cab Service provides reliable Mumbai to Lonavala cab service with professional drivers, comfortable vehicles, and smooth travel for family trips, weekend getaways, and sightseeing tours."
  },
  {
    WhyChooseheading: "Affordable Mumbai to Lonavala Taxi Fare",
    WhyChoosedescription: "Our Mumbai to Lonavala taxi service offers affordable pricing with transparent fare details and no hidden charges for one-way and round-trip travel bookings."
  },
  {
    WhyChooseheading: "24/7 Mumbai to Lonavala Cab Availability",
    WhyChoosedescription: "Om Sai Cab Service operates 24 hours a day for Mumbai to Lonavala cab bookings including weekend travel, holiday trips, corporate outings, and emergency transportation."
  },
  {
    WhyChooseheading: "Comfortable AC Cabs for Lonavala Travel",
    WhyChoosedescription: "All Mumbai to Lonavala taxis are fully air-conditioned, sanitized, spacious, and maintained regularly for smooth and comfortable highway journeys."
  },
  {
    WhyChooseheading: "One Way & Round Trip Taxi Booking",
    WhyChoosedescription: "Customers can choose one-way Mumbai to Lonavala cab service, round-trip taxi bookings, return travel, and customized sightseeing packages."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Choices",
    WhyChoosedescription: "Om Sai Cab Service offers sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers suitable for couples, families, tourists, and group tours."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide pickup service from Mumbai Airport, Navi Mumbai, Thane, hotels, homes, railway stations, and all major Mumbai locations for convenient travel."
  },
  {
    WhyChooseheading: "Experienced Drivers for Expressway Routes",
    WhyChoosedescription: "Our experienced drivers are familiar with Mumbai-Pune Expressway routes and Lonavala hill roads, ensuring safe driving and timely arrival."
  }
]
};

const faqData = [
  {
    question: "What is Mumbai to Lonavala cab service?",
    answer: "Mumbai to Lonavala cab service provides comfortable taxi transportation from Mumbai to Lonavala for sightseeing, family trips, and weekend vacations."
  },
  {
    question: "Is Mumbai to Lonavala cab service available 24 hours?",
    answer: "Yes, Om Sai Cab Service provides 24/7 Mumbai to Lonavala taxi service."
  },
  {
    question: "Which vehicles are available for Mumbai to Lonavala travel?",
    answer: "Customers can choose sedan taxis, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers."
  },
  {
    question: "Can I book a one-way cab from Mumbai to Lonavala?",
    answer: "Yes, one-way as well as round-trip Mumbai to Lonavala cab bookings are available."
  },
  {
    question: "Do you provide pickup from Mumbai Airport and hotels?",
    answer: "Yes, pickup service is available from Mumbai Airport, hotels, railway stations, homes, and all major Mumbai areas."
  },
  {
    question: "Are all Mumbai to Lonavala taxis air-conditioned?",
    answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable travel."
  },
  {
    question: "Can I book Mumbai to Lonavala cab service online?",
    answer: "Yes, customers can easily book Mumbai to Lonavala cab service online or through phone booking."
  },
  {
    question: "Do you provide sightseeing taxi packages for Lonavala?",
    answer: "Yes, customized sightseeing packages are available for Lonavala tourist attractions and nearby destinations."
  },
  {
    question: "Are Mumbai to Lonavala cab fares transparent?",
    answer: "Yes, Om Sai Cab Service provides affordable and transparent pricing without hidden charges."
  },
  {
    question: "Is advance booking available for Mumbai to Lonavala cabs?",
    answer: "Yes, advance booking is available and recommended during weekends, holidays, and monsoon tourist seasons."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ajinkya Patil",
    feedback: "Om Sai Cab Service made our Mumbai to Lonavala trip very comfortable. The cab was clean, and the driver ensured a smooth and safe drive on the expressway.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback: "Our Mumbai to Lonavala cab journey with Om Sai Cab Service was very pleasant. The pickup was on time, and the ride felt relaxed and hassle-free throughout.",
    rating: 5
  }
];


















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai to Goa Cab", link: "Mumbai-to-Goa-Cab" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Goa Cab Booking", link: "Mumbai-to-Goa-Cab-Booking" },
        { place: "/images/keyword/3.jpg", text: "Navi Mumbai to Goa Cab Service", link: "Navi-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/4.jpg", text: "Mumbai Airport to Goa Cab", link: "Mumbai-Airport-to-Goa-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Goa Cab Service", link: "Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Best Mumbai to Goa Cab Service", link: "Best-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/7.jpg", text: "Thane to Goa Cabs", link: "Thane-to-Goa-Cabs" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Goa Innova Crysta Cab", link: "Mumbai-to-Goa-Innova-Crysta-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Goa One Way Cab", link: "Mumbai-to-Goa-One-Way-Cab" },
        { place: "/images/keyword/10.jpg", text: "Goa Cabs Service", link: "Goa-Cabs-Service" },
        { place: "/images/keyword/11.jpg", text: "Goa to Mumbai Cab", link: "Goa-to-Mumbai-Cab" },
        { place: "/images/keyword/12.jpg", text: "Goa to Navi Mumbai Cab", link: "Goa-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/13.jpg", text: "Goa to Mumbai Airport Cab", link: "Goa-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/14.jpg", text: "Goa to Mumbai One Way Cab", link: "Goa-to-Mumbai-One-Way-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/16.jpg", text: "Lonavala to Mumbai Cab", link: "Lonavala-to-Mumbai-Cab" },
        { place: "/images/keyword/17.jpg", text: "Best Lonavala to Navi Mumbai Cab", link: "Best-Lonavala-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/18.jpg", text: "Navi Mumbai Airport Cab", link: "Navi-Mumbai-Airport-Cab" },
        { place: "/images/keyword/19.jpg", text: "Navi Mumbai Cab Service", link: "Navi-Mumbai-Cab-Service" },
        { place: "/images/keyword/20.jpg", text: "Kharghar Taxi Services", link: "Kharghar-Taxi-Services" },
        { place: "/images/keyword/21.jpg", text: "Mumbai Airport Cabs", link: "Mumbai-Airport-Cabs" },
        { place: "/images/keyword/22.jpg", text: "Mumbai Cab Service", link: "Mumbai-Cab-Service" },
        { place: "/images/keyword/23.jpg", text: "Mumbai Online Cab Service", link: "Mumbai-Online-Cab-Service" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/25.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/26.jpg", text: "Innova Crysta On Rent in Mumbai", link: "Innova-Crysta-On-Rent-in-Mumbai" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Lonavala Cab Service",
  "image": "http://www.omsaicabservice.com/assets/images/mumbai-to-lonavala-cab.jpg",
  "description": "Book Mumbai to Lonavala cab service with Om Sai Cab Service for one-way, round-trip, and package trips. Affordable Sedan, SUV, Ertiga, Swift Dzire, Innova, and Innova Crysta cabs available for airport transfers, weekend trips, and family travel with 24x7 support.",
  "brand": {
    "@type": "Brand",
    "name": "Om Sai Cab Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "http://www.omsaicabservice.com/mumbai-to-lonavala-cab"
  }
};







    return (
        <div>
<Helmet>
  <title>
    Mumbai to Lonavala Cab Service | One Way & Weekend Packages | +91 9594849797
  </title>

  <meta
    name="description"
    content="Book Mumbai to Lonavala cab service at affordable fares. One-way taxi, round-trip packages, and weekend trips available with Sedan, SUV, Ertiga, Swift Dzire, Innova, and Innova Crysta cabs. Ideal for family and hill station travel."
  />

  <meta
    name="keywords"
    content="mumbai to lonavala taxi, Mumbai to lonavala cab package, Mumbai to lonavala taxi price, One way cab from mumbai to lonavala, mumbai to lonavala taxi cost, mumbai to lonavala car rental, mumbai to lonavala cab price, mumbai to lonavala car rental price, mumbai to lonavala cab booking, Lonavala cab for 2 days, cab service from mumbai to lonavala, Mumbai airport to lonavala cab, Mumbai airport to lonavala taxi fare, mumbai lonavala cab service, mumbai central to lonavala taxi fare, mumbai lonavala taxi fare, mumbai to lonavala cab charges, Mumbai to Lonavala Innova Cab, Mumbai to Lonavala Innova Crysta Cab, Mumbai to Lonavala Ertiga Cab, Mumbai to Lonavala Swift Dzire Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row align-items-center text-center">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/15.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FFCC00', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Om Sai Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Om Sai Cab</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Om Sai Cab </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                             <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919594849797" className="pc-call">+91 9594849797</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919594849797"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919594849797" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@omsaicabservice.com" className="pc-email">
                                            booking@omsaicabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Om Sai Cab Service</strong><br />
                                            Shree Vishal CHS Ltd., Plot No.17,
                                            Sector 18, Kopar Khairane, Navi Mumbai,
                                            Maharashtra- India - 400709
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitolonavalacab;